import { useEffect, useState, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Tab,
  Nav,
  Card,
  Button,
  Form,
} from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "../css/swiper.css";
import { Link } from "react-router-dom";
import { Navigation, Pagination } from "swiper/modules";
import { getLatestBlogsAction } from "../../apis/apiAction";
import { FaAngleRight, FaAngleLeft } from "react-icons/fa6";

const LatestBlogs = () => {
  const [blogData, setBlogData] = useState([]);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const swiperRef = useRef(null); // Store Swiper instance

  useEffect(() => {
    getLatestBlogs();
  }, []);

  const getLatestBlogs = async () => {
    const res = await getLatestBlogsAction();
    setBlogData(res.data);
  };

  useEffect(() => {
    if (swiperRef.current) {
      swiperRef.current.params.navigation.prevEl = prevRef.current;
      swiperRef.current.params.navigation.nextEl = nextRef.current;
      swiperRef.current.navigation.init();
      swiperRef.current.navigation.update();
    }
  }, [blogData]); // Re-run when blogData is fetched

  return (
    <>
      <Container>
        <Row className="justify-content-center text-center ">
          <Col lg={12} className="mb-5">
            <div className="position-relative">
              {/* Custom Prev Button */}
              <button ref={prevRef} className="custom-prev">
                <FaAngleLeft />
              </button>
              <Swiper
                slidesPerView={1}
                spaceBetween={10}
                breakpoints={{
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  768: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                  },
                  1024: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                  },
                }}
                nonSwiper={(swiper) => (swiperRef.current = swiper)} // Store instance
                navigation={{
                  prevEl: prevRef.current,
                  nextEl: nextRef.current,
                }}
                loop={true}
                modules={[Navigation]}
                className="mySwiper"
              >
                {blogData.map(
                  (blog, index) =>
                    index < 5 && (
                      <SwiperSlide>
                        <div className="">
                          <Card className="lightBlueCard rounded-5 p-3 text-start">
                            <Card.Img variant="top" src={blog.imageUrl} />
                            <Card.Body
                              as={Link}
                              to={blog.link}
                              arget="_blank"
                              className="pb-0"
                            >
                              <Card.Title className="text-white">
                                {blog.title}
                              </Card.Title>
                              <div className="text-primary fw-semibold mt-3">
                                {blog.publishedDate}
                              </div>
                              {/* <Card.Text className="mb-4"></Card.Text> */}
                            </Card.Body>
                          </Card>
                        </div>
                      </SwiperSlide>
                    )
                )}
              </Swiper>
              {/* Custom Next Button */}
              <button ref={nextRef} className="custom-next">
                <FaAngleRight />
              </button>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};
export default LatestBlogs;
